// extracted by mini-css-extract-plugin
export default {"rounded":"styles_rounded__LiCDX"};